module.exports = __webpack_public_path__ + "static/intertec_screen_3.1-0d28cddadc4837d549ee0110b3562786.jpg";